import type { CoworldSwitcherState } from "@softmax/web-ux/shell";
import type { useRoute } from "../../navigation/use-route";
import type { PortfolioSeatLike, CoworldTarget } from "./coworld-switcher-data";
import type { LeagueDirectoryEntry } from "./league-directory";
import { switcherRows } from "./switcher-rows";

export function switcherState({
  entries,
  seats,
  current,
  route,
  query,
  pending,
  failed,
}: {
  readonly entries: LeagueDirectoryEntry[] | undefined;
  readonly seats: PortfolioSeatLike[] | undefined;
  readonly current: CoworldTarget | null;
  readonly route: ReturnType<typeof useRoute>;
  readonly query: string;
  readonly pending: boolean;
  readonly failed: boolean;
}): CoworldSwitcherState {
  if (entries && seats) {
    let refresh: Extract<
      CoworldSwitcherState,
      {
        readonly status: "ready";
      }
    >["refresh"] = { status: "idle" };

    if (pending) refresh = { status: "loading" };
    else if (failed)
      refresh = {
        status: "error",
        message:
          "Could not refresh coworlds. Showing the last available results.",
      };

    return {
      status: "ready",
      rows: switcherRows({
        seats,
        directory: entries,
        current,
        route,
        query,
      }),
      refresh,
    };
  } else if (failed && !pending) {
    return { status: "error", message: "Could not load coworlds." };
  }

  return { status: "loading" };
}
